import { useEffect, useRef, useState } from 'react';
import { Copy, Eye, EyeOff, RefreshCw } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { generateStaffPassword } from './staffPassword';
import './staff-password.css';

export const StaffPasswordField = ({ value, onChange, busy }) => {
  const [visible, setVisible] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [copying, setCopying] = useState(false);
  const currentValue = useRef(value);
  currentValue.current = value;
  useEffect(() => {
    const hide = () => setVisible(false);
    window.addEventListener('blur', hide);
    document.addEventListener('visibilitychange', hide);
    return () => { window.removeEventListener('blur', hide); document.removeEventListener('visibilitychange', hide); };
  }, []);
  const change = next => { setMessage(''); setError(''); onChange(next); };
  const generate = () => {
    setMessage(''); setError('');
    try { change(generateStaffPassword()); setVisible(false); }
    catch { setError('Güvenli şifre oluşturulamadı. Şifreyi elle girebilirsiniz.'); }
  };
  const copy = async () => {
    if (!value || copying || busy) return;
    const snapshot = value;
    setMessage(''); setError(''); setCopying(true);
    try {
      if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
      await navigator.clipboard.writeText(snapshot);
      if (currentValue.current === snapshot) setMessage('Şifre kopyalandı.');
    } catch {
      if (currentValue.current === snapshot) setError('Kopyalanamadı. Şifreyi gösterip elle kopyalayabilirsiniz.');
    } finally { setCopying(false); }
  };
  return <div className="crm-staff-password" data-testid="crm-staff-password-field">
    <label htmlFor="staff-password">Şifre</label>
    <div className="crm-staff-password-controls">
      <Input id="staff-password" data-testid="crm-staff-password" type={visible ? 'text' : 'password'} value={value} onChange={e => change(e.target.value)} required minLength={12} maxLength={72} autoComplete="new-password" spellCheck={false} autoCapitalize="none" disabled={busy} aria-describedby={error ? 'staff-password-error' : message ? 'staff-password-status' : undefined}/>
      <Button type="button" variant="outline" className="crm-staff-password-icon" data-testid="crm-staff-password-visibility" title={visible ? 'Şifreyi gizle' : 'Şifreyi göster'} aria-label={visible ? 'Şifreyi gizle' : 'Şifreyi göster'} aria-pressed={visible} disabled={busy || !value} onClick={() => setVisible(!visible)}>{visible ? <EyeOff size={17}/> : <Eye size={17}/>}</Button>
      <Button type="button" variant="outline" className="crm-staff-password-icon" data-testid="crm-staff-password-copy" title="Şifreyi kopyala" aria-label="Şifreyi kopyala" disabled={busy || copying || !value} onClick={copy}><Copy size={17}/></Button>
      <Button type="button" variant="outline" className="crm-staff-password-generate" data-testid="crm-staff-password-generate" disabled={busy} onClick={generate}><RefreshCw size={16}/>Şifre Oluştur</Button>
    </div>
    {message && <p id="staff-password-status" role="status" className="crm-staff-password-status" data-testid="crm-staff-password-status">{message}</p>}
    {error && <p id="staff-password-error" role="alert" className="crm-error" data-testid="crm-staff-password-error">{error}</p>}
  </div>;
};